import { DashboardFeatureCardProps } from './DashboardFeatureCard';

const DASHBOARD_IMAGES = '/images/Dashboard-Images';

export type DashboardCardConfig = DashboardFeatureCardProps & {
  id: string;
};

export const dashboardCards: DashboardCardConfig[] = [
  {
    id: 'ecommerce-photoshoot',
    to: '/ecommerce-photoshoot',
    title: 'Ecommerce Photoshoot',
    description: 'Create professional ecommerce product photos with AI models and studio backdrops.',
    beforeImage: `${DASHBOARD_IMAGES}/ecommerce-photoshoot/ecommerce-photo-before.webp`,
    afterImage: `${DASHBOARD_IMAGES}/ecommerce-photoshoot/ecommerce-photo-after-1.webp`,
  },
  {
    id: 'fashion-extractor',
    to: '/fashion-extractor',
    title: 'Outfit Extractor (Flatlay)',
    description: 'Extract outfits from photos and turn them into clean product-ready visuals.',
    beforeImage: `${DASHBOARD_IMAGES}/outfit-extractor/outfit-extractor-before.webp`,
    afterImage: `${DASHBOARD_IMAGES}/outfit-extractor/outfit-extractor-after.webp`,
  },
  {
    id: 'ghost-mannequin',
    to: '/ghost-mannequin',
    title: 'Ghost Mannequin',
    description: 'Turn mannequin or hanger shots into professional hollow-neck ghost mannequin product images.',
    beforeImage: `${DASHBOARD_IMAGES}/ghost-mannequin/ghost-mannequin-before.jpg`,
    afterImage: `${DASHBOARD_IMAGES}/ghost-mannequin/ghost-mannequin-after.jpeg`,
  },
  {
    id: 'wrinkle-removal',
    to: '/wrinkle-removal',
    title: 'Wrinkle Removal',
    description: 'Smooth wrinkles from garment photos for crisp, retail-ready product images.',
    beforeImage: `${DASHBOARD_IMAGES}/wrinkle-removal/wrinkle-removal-before.webp`,
    afterImage: `${DASHBOARD_IMAGES}/wrinkle-removal/wrinkle-removal-after.webp`,
  },
  {
    id: 'ai-poses',
    to: '/ai-poses',
    title: 'AI Pose Change',
    description: 'Change model poses in your photos while keeping garments and styling intact.',
    beforeImage: `${DASHBOARD_IMAGES}/ai-pose-change/ai-pose-change-before.webp`,
    afterImage: `${DASHBOARD_IMAGES}/ai-pose-change/ai-pose-change-after.webp`,
  },
  {
    id: 'dummy-photoshoot',
    to: '/try-on',
    title: 'Dummy / Mannequin to AI Model',
    description: 'Transform mannequin or flat-lay shots into realistic on-model catalogue photos.',
    beforeImage: `${DASHBOARD_IMAGES}/dummy-photoshoot/dummy-before.webp`,
    afterImage: `${DASHBOARD_IMAGES}/dummy-photoshoot/dummy-after.webp`,
  },
  {
    id: 'upscaler',
    to: '/canvas-editor',
    title: '4K Resolution Converter',
    description: 'Upscale images to 4K resolution for sharper, high-quality product visuals.',
    beforeImage: `${DASHBOARD_IMAGES}/upscaler/upscaler-before.webp`,
    afterImage: `${DASHBOARD_IMAGES}/upscaler/upscaler-after.webp`,
    tool: 'upscaler',
  },
  {
    id: 'flatlay-to-model-ai',
    to: '/try-on',
    title: 'Flatlay to Model AI',
    description: 'Turn flatlay garment photos into realistic on-model catalogue images with AI.',
    beforeImage: `${DASHBOARD_IMAGES}/flatlay-to-model/flatlay-to-model-before.webp`,
    afterImage: `${DASHBOARD_IMAGES}/flatlay-to-model/flatlay-to-model-after.webp`,
  },
  {
    id: 'background-removal',
    to: '/canvas-editor',
    title: 'Background Removal',
    description: 'Remove backgrounds from images for clean, transparent product cutouts.',
    beforeImage: `${DASHBOARD_IMAGES}/background-removal/background-removal-before.webp`,
    afterImage: `${DASHBOARD_IMAGES}/background-removal/background-removal-after.webp`,
    tool: 'background-removal',
  },
  {
    id: 'active-wear-photoshoot',
    to: '/gym-wear-photoshoot',
    title: 'Gym & Yoga Wear Photoshoot',
    description: 'Generate studio-grade gym and yoga wear catalogue shots with AI models and poses.',
    beforeImage: `${DASHBOARD_IMAGES}/gym-wear/gym-wear-before.webp`,
    afterImage: `${DASHBOARD_IMAGES}/gym-wear/gym-wear-after.webp`,
  },
  // {
  //   id: 'fashion-reels',
  //   to: '/canvas-editor',
  //   title: 'Fashion Reels',
  //   description: 'Turn static fashion images into short-form video reels for social media.',
  //   variant: 'reels',
  //   reelsImage: `${DASHBOARD_IMAGES}/Feature-Images/reelsImage.jpeg`,
  //   reelsVideo: `${DASHBOARD_IMAGES}/Feature-Images/video-generation-9d95071c-9c3e-49ee-a22a-ace0a071a885-video-1.mp4`,
  // },
];
